module.exports = __webpack_public_path__ + "img/creat-time.6f5967dc.svg";